import {
  collection,
  query,
  where,
  getDocs,
  WhereFilterOp,
} from 'firebase/firestore';
import { dataBase } from './firebaseConfig';
import { COLLECTIONS } from '../constants';

export type Filter = {
  field: string;
  operator: WhereFilterOp;
  value: string | number;
};

export const getFirestoreItemsByQueries = async (
  filters: Filter[],
  collectionName: string = COLLECTIONS.listings,
) => {
  try {
    let q = query(collection(dataBase, collectionName));

    filters.forEach(({ field, operator, value }) => {
      q = query(q, where(field, operator, value));
    });

    const querySnapshot = await getDocs(q);

    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error('Error while getting items:', error);
    return [];
  }
};
